import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  year: {
    marginLeft: 10,
    marginTop: 10,
    width: 40,
    height: 10,
  },
  status: {
    marginTop: 10,
    height: 10,
    width: 60,
  },
  month: {
    marginLeft: 10,
    marginTop: 15,
    width: 100,
    height: 10,
  },
  price: {
    marginTop: 15,
    width: 100,
    height: 10,
  },
  line: {
    marginTop: 25,
    marginLeft: 10,
    height: 2,
    width: 330,
  },
  serviceIcon: {
    marginTop: 15,
    marginRight: 1,
    alignSelf: 'center',
    marginLeft: 10,
  },
  arrow: {
    marginTop: 15,
    marginRight: 20,
    alignSelf: 'flex-end',
  },
});
